import { Component } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { ToastService } from '../toast/service/toast.service';
import { getCrudErrors } from '../../utils/functions';

@Component({
  selector: 'l-impersonation-banner',
  standalone: true,
  host: { class: 'block shrink-0' },
  template: `
    @if (isImpersonating) {
      <div
        class="flex h-12 w-full items-center justify-between text-white bg-lSuccess px-6"
        role="status"
        aria-label="Ambiente de impersonação"
      >
        <span class="text-sm font-medium">Ambiente de impersonação</span>
        <button
          type="button"
          class="rounded-full border border-white bg-white/10 px-5 py-1 text-sm font-medium disabled:opacity-60"
          [disabled]="isStopping"
          (click)="disconnect()"
        >
          Desconectar
        </button>
      </div>
    }
  `,
})
export class ImpersonationBannerComponent {

  constructor(
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
  ) {}

  public isStopping: boolean = false;

  public get isImpersonating(): boolean {
    return this.authService.isImpersonating();
  }

  public async disconnect(): Promise<void> {
    if (this.isStopping || !this.isImpersonating) {
      return;
    }

    try {
      this.isStopping = true;
      await this.authService.stopImpersonation();
    } catch (error) {
      this.isStopping = false;
      this.toastService.error(getCrudErrors(error)[0], 'Oops...');
    }
  }

}
